import React from 'react';
let context;
var moment = require('moment');
class Event extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idevent: 0,
            name: '',
            timestamp: '',
            status: '',
            ihome: '',
            home: '',
            iaway: '',
            away: '',
            league: '',
            data: {},
        }
        this.goBack = this.goBack.bind(this);
        context = this;
    }
    componentDidMount() {
        window.scroll(0, 0);

    }
    goBack(){
        this.props.history.goBack();
    }
    static getDerivedStateFromProps(props, current_state) {


        if (current_state.idevent !== props.match.params.idevent) {


            context.setState({
                event: {},
                loading: true,
                idevent: props.match.params.idevent,

            })

            // console.log("Se actualizo la prop ", props.match.params.idsport, props.match.params.idpais);
            if (props.match.params.idevent)
                fetch(props.api + '/view/model/event/id/' + props.match.params.idevent, { cache: "no-cache" })
                    .then(results => {
                        return results.json();
                    }).then(event => {
                        context.setState({
                            ...event,
                            loading: true
                        })
                        // localStorage.setItem('select', JSON.stringify(select));
                        // console.table(data)
                    }).catch(function (error) {
                        // console.log('Hubo un problema con la petición Fetch:' + error.message);
                        context.setState({ loading: false })
                    });

        }

        return null;

    }
    // componentWillUnmount() {

    //     this.setState({ event: [] })


    // }
    render() {
        // let w = -1;
        let rawTimes = this.state.data;
        let times = Object.keys(rawTimes);
        let leagueName = this.props.language(this.state.sport).text + ' - ' + this.state.country + ' ' + this.state.league;


        // let arrayData = times.map(i => { return rawTimes[i] })
        // console.log(arrayData)
        let accordionTime = times.map(index => {

            let m = rawTimes[index].offers;
            let ids = Object.keys(m);
            let offer = ids.map(mo => {
                // let o = m[mo];
                let body = m[mo].data;
                let yy = Object.keys(body).map(yo => {
                    let jj = body[yo];

                    let c1 = jj.o1;
                    let c2 = jj.o2;
                    let c3 = jj.o3;
                    // let c4 = jj.o4;


                    switch (m[mo].type) {

                        case "1":
                            return (
                                <div className="row" key={yo}>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '791'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }
                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 1,
                                                        id: this.state.idevent + "89" + m[mo].id + '791',
                                                        idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        odd: c1,
                                                        option: m[mo].PCUU_O1 === "1" ? this.state.home : m[mo].PCUU_O1,
                                                        price: c1,
                                                        time: this.state.timestamp,
                                                        type: m[mo].id,
                                                        version: jj.version,
                                                        liga: leagueName,
                                                    })}>
                                            <span className="text pb-1">{this.props.format(c1)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O1 === '1' ? this.state.home : this.props.language(m[mo].PCUU_O1).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '792'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }
                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 2,
                                                        id: this.state.idevent + "89" + m[mo].id + '792',
                                                        odd: c2,
                                                        logro: m[mo].shortName,
                                                        idmatch: this.state.idevent,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O2 === "X" ? this.props.language().draw : m[mo].PCUU_O2,
                                                        version: jj.version,
                                                        price: c2

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c2)} </span>
                                            <span className="odds animate">{m[mo].PCUU_O2 === 'X' ? this.props.language().draw : this.props.language(m[mo].PCUU_O2).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '793'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 3,
                                                        id: this.state.idevent + "89" + m[mo].id + '793',
                                                        odd: c3, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O3 === "2" ? this.state.away : m[mo].PCUU_O3,
                                                        version: jj.version,
                                                        price: c3

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c3)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O3 === '2' ? this.state.away : this.props.language(m[mo].PCUU_O3).text}</span>
                                        </button>
                                    </div>
                                </div>
                            )

                        case "2":
                            return (
                                <div className="row" key={yo}>
                                    <div className="col-sm-6 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '791'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 1,
                                                        id: this.state.idevent + "89" + m[mo].id + '791',
                                                        odd: c1, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O1 === "1" ? this.state.home : m[mo].PCUU_O1,
                                                        version: jj.version,
                                                        price: c1

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c1)} </span>
                                            <span className="odds animate">{m[mo].PCUU_O1 === "1" ? this.state.home : this.props.language(m[mo].PCUU_O1).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-6 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '792'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 2,
                                                        id: this.state.idevent + "89" + m[mo].id + '792',
                                                        odd: c2, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O2 === "2" ? this.state.away : m[mo].PCUU_O2,
                                                        version: jj.version,
                                                        price: c2

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c2)} </span>
                                            <span className="odds animate">{m[mo].PCUU_O2 === "2" ? this.state.away : this.props.language(m[mo].PCUU_O2).text}</span>
                                        </button>
                                    </div>

                                </div>
                            )
                        case "3x":
                            return (
                                <div className="row" key={yo}>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '791'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 1,
                                                        id: this.state.idevent + "89" + m[mo].id + '791',
                                                        odd: c1, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O1 === "1" ? this.state.home : m[mo].PCUU_O1,
                                                        version: jj.version,
                                                        price: c1

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c1)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O1 === '1' ? this.state.home : this.props.language(m[mo].PCUU_O1).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '792'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 2,
                                                        id: this.state.idevent + "89" + m[mo].id + '792',
                                                        odd: c2, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O2 === "X" ? this.props.language().draw : m[mo].PCUU_O2,
                                                        version: jj.version,
                                                        price: c2

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c2)} </span>
                                            <span className="odds animate">{m[mo].PCUU_O2 === 'X' ? this.props.language().draw : this.props.language(m[mo].PCUU_O2).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '793'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 3,
                                                        id: this.state.idevent + "89" + m[mo].id + '793',
                                                        odd: c3, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O3 === "2" ? this.state.away : m[mo].PCUU_O3,
                                                        version: jj.version,
                                                        price: c3

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c3)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O3 === '2' ? this.state.away : this.props.language(m[mo].PCUU_O3).text}</span>
                                        </button>
                                    </div>
                                </div>
                            )
                        case "4":
                            return (
                                <div className="row" key={yo}>
                                    <div className="col-sm-6 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '791'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }
                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 1,
                                                        id: this.state.idevent + "89" + m[mo].id + '791',
                                                        odd: c1, idmatch: this.state.idevent,
                                                        handicap: c3,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O1 === "1" ? this.state.home : m[mo].PCUU_O1,
                                                        version: jj.version,
                                                        price: c1

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c1)} </span>
                                            <span className="odds animate">{this.props.language(m[mo].PCUU_O1).text + ' ' + c3}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-6 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '792'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 2,
                                                        id: this.state.idevent + "89" + m[mo].id + '792',
                                                        odd: c2, idmatch: this.state.idevent,
                                                        handicap: c3,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O2 === "X" ? this.props.language().draw : m[mo].PCUU_O2,
                                                        version: jj.version,
                                                        price: c2

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c2)} </span>
                                            <span className="odds animate">{this.props.language(m[mo].PCUU_O2).text + ' ' + c3}</span>
                                        </button>
                                    </div>

                                </div>
                            )
                        case "5x":
                            return (
                                <div className="row" key={yo}>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '791'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 1,
                                                        id: this.state.idevent + "89" + m[mo].id + '791',
                                                        odd: c1, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O1 === "1" ? this.state.home : m[mo].PCUU_O1,
                                                        version: jj.version,
                                                        price: c1

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c1)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O1 === '1' ? this.state.home : this.props.language(m[mo].PCUU_O1).text}</span>
                                        </button>
                                    </div>
                                </div>
                            )
                        case "6x":
                            return (
                                <div className="row" key={yo}>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '792'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 2,
                                                        id: this.state.idevent + "89" + m[mo].id + '792',
                                                        odd: c1, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O1 === "1" ? this.state.home : m[mo].PCUU_O1,
                                                        version: jj.version,
                                                        price: c1

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c1)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O1 === '1' ? this.state.home : this.props.language(m[mo].PCUU_O1).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '793'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 3,
                                                        id: this.state.idevent + "89" + m[mo].id + '793',
                                                        odd: c2, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O2 === "X" ? this.props.language().draw : m[mo].PCUU_O2,
                                                        version: jj.version,
                                                        price: c2

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c2)} </span>
                                            <span className="odds animate">{m[mo].PCUU_O2 === 'X' ? this.props.language().draw : this.props.language(m[mo].PCUU_O2).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '793'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 3,
                                                        id: this.state.idevent + "89" + m[mo].id + '793',
                                                        odd: c3, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O3 === "2" ? this.state.away : m[mo].PCUU_O3,
                                                        version: jj.version,
                                                        price: c3

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c3)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O3 === '2' ? this.state.away : this.props.language(m[mo].PCUU_O3).text}</span>
                                        </button>
                                    </div>
                                </div>
                            )
                        case "7":
                            return (
                                <div className="row" key={yo}>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '791'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 1,
                                                        id: this.state.idevent + "89" + m[mo].id + '791',
                                                        odd: c1, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O1 === "1" ? this.state.home : m[mo].PCUU_O1,
                                                        version: jj.version,
                                                        price: c1

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c1)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O1 === '1' ? this.state.home : this.props.language(m[mo].PCUU_O1).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '792'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 2,
                                                        id: this.state.idevent + "89" + m[mo].id + '792',
                                                        odd: c2, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O2 === "X" ? this.props.language().draw : m[mo].PCUU_O2,
                                                        version: jj.version,
                                                        price: c2

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c2)} </span>
                                            <span className="odds animate">{m[mo].PCUU_O2 === 'X' ? this.props.language().draw : this.props.language(m[mo].PCUU_O2).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '793'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }

                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 3,
                                                        id: this.state.idevent + "89" + m[mo].id + '793',
                                                        odd: c3, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O3 === "2" ? this.state.away : m[mo].PCUU_O3,
                                                        version: jj.version,
                                                        price: c3

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c3)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O3 === '2' ? this.state.away : this.props.language(m[mo].PCUU_O3).text}</span>
                                        </button>
                                    </div>
                                </div>
                            )


                        default:
                            return (
                                <div className="row" key={yo}>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '791'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }
                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 1,
                                                        id: this.state.idevent + "89" + m[mo].id + '791',
                                                        odd: c1, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O1 === "1" ? this.state.home : m[mo].PCUU_O1,
                                                        version: jj.version,
                                                        price: c1

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c1)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O1 === '1' ? this.state.home : this.props.language(m[mo].PCUU_O1).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '792'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }
                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 2,
                                                        id: this.state.idevent + "89" + m[mo].id + '792',
                                                        odd: c2, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O2 === "X" ? this.props.language().draw : m[mo].PCUU_O2,
                                                        version: jj.version,
                                                        price: c2

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c2)} </span>
                                            <span className="odds animate">{m[mo].PCUU_O2 === 'X' ? this.props.language().draw : this.props.language(m[mo].PCUU_O2).text}</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-4 p-1">
                                        <button
                                            className={
                                                this.props.items[this.state.idevent + "89" + m[mo].id + '793'] ?
                                                    "button-special border border-info active" : "button-special border border-info"
                                            }
                                            onClick={
                                                this.props.addTocart.bind(this,
                                                    {
                                                        choose: 3,
                                                        id: this.state.idevent + "89" + m[mo].id + '793',
                                                        odd: c3, idmatch: this.state.idevent,
                                                        logro: m[mo].shortName,
                                                        name: this.state.name,
                                                        time: this.state.timestamp,
                                                        liga: leagueName,
                                                        type: m[mo].id,
                                                        option: m[mo].PCUU_O3 === "2" ? this.state.away : m[mo].PCUU_O3,
                                                        version: jj.version,
                                                        price: c3

                                                    })}>
                                            <span className="text pb-1">{this.props.format(c3)} </span>
                                            <span className="odds animate text-truncate">{m[mo].PCUU_O3 === '2' ? this.state.away : this.props.language(m[mo].PCUU_O3).text}</span>
                                        </button>
                                    </div>
                                </div>
                            )
                    }
                })

                return (
                    <div key={mo} className="col-md-6">
                        <div className="card sports-highlights">
                            <h6 className="card-header"> {this.props.language(m[mo].name).text}</h6>
                            <div className='card-body'>
                                {yy}
                            </div>
                        </div>
                    </div>
                )
            })
            return (<div key={index} className={"mt-2 accordion"} id="myAccordion" style={{ textAlign: "left" }}>
                <div className="card-header  border-bottom">
                    <a data-toggle="collapse" href={"#Fest" + index} data-parent="#myAccordion" aria-expanded="true" aria-controls={"Fest" + index}>
                        <h5 className="font-thin d-flex justify-content-between"><span><i className="fas fa-hashtag"></i> {rawTimes[index].name}</span> <i className="fa fa-angle-down rotate-icon"></i></h5>
                    </a>
                </div>
                <div id={"Fest" + index} className={"collapse show"} aria-labelledby={"Hest"} data-parent="#myAccordion">
                    <div className="card-body p-0">
                        <div className="pt-3 "></div>
                        <div className="row">
                            {offer}
                        </div>
                    </div>
                </div>
            </div>)



        })
        return (
            <div className="centerPanel">
                <div className='mb-3'>

                    {/* Header */}
                    <div className="row mb-3" >
                        <div className="col-sm-12" >
                            <button className="btn btn-sm btn-success text-left mb-2" onClick={this.goBack}><i className="fas fa-step-backward"></i> {this.props.language().back}</button>
                            <div className="card sports-highlights mb-2 " >
                                <h6 className="card-header justify-content-between d-flex">
                                    <span><i className={"ficon-inline f-" + this.state.countryId}></i>  {leagueName}</span>
                                    <small>  {moment(this.state.timestamp * 1000).calendar()}</small>
                                </h6>
                                <div className="card-body text-center p-0" style={{ height: '100%', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundImage: "url(/img/event.jpg)" }} >
                                    <div className="n p-2" style={{ backgroundColor: "#000000d9" }}>
                                        <h6 className="card-title d-flex justify-content-between">
                                            {/* {this.state.idevent} */}

                                            <img width='50' height='50' src={"http://kingdeportes.com/geek/themes/flat/img/logos/" + this.state.ihome + ".png"} alt="..." className="rounded-circle m-2" />
                                            {this.state.name}
                                            <img width='50' height='50' src={"http://kingdeportes.com/geek/themes/flat/img/logos/" + this.state.iaway + ".png"} alt="..." className="rounded-circle m-2" />
                                        </h6>
                                        <span style={{ position: 'relative', top: -25, color: '#0bd061' }}>{this.props.language('sheduled').text}</span>
                                        <small style={{ position: 'relative', top: -35, color: 'white', display: 'block' }}>{moment(this.state.timestamp * 1000).format('MMM DD, YYYY - H:mm')}</small>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* Statistic */}

                        <div className="col-sm-4 d-none ">
                            <div className="card sports-highlights">
                                <div className="card-header">
                                    <h6>Estadisticas</h6>
                                </div>
                                <div className="card-body">
                                    <div className="progress " style={{ height: "20px" }}>
                                        <div className="progress-bar  bg-success" role="progressbar" style={{ color: '#12242e', fontWeight: 'bolder', width: "33.3333333%" }} aria-valuenow="33" aria-valuemin="0" aria-valuemax="100">33%</div>
                                        <div className="progress-bar  bg-warning" role="progressbar" style={{ color: '#12242e', fontWeight: 'bolder', width: "33.3333333%" }} aria-valuenow="33" aria-valuemin="0" aria-valuemax="100">33%</div>
                                        <div className="progress-bar  bg-info" role="progressbar" style={{ color: '#12242e', fontWeight: 'bolder', width: "33.3333333%" }} aria-valuenow="33" aria-valuemin="0" aria-valuemax="100">33%</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-8  d-none">
                            <div className="card sports-highlights">
                                <div className="card-header">
                                    <h6>Estadisticas</h6>
                                </div>
                                <div className="card-body">
                                    <div className="progress " style={{ height: "20px" }}>
                                        <div className="progress-bar  bg-success" role="progressbar" style={{ color: '#12242e', fontWeight: 'bolder', width: "33.3333333%" }} aria-valuenow="33" aria-valuemin="0" aria-valuemax="100">33%</div>
                                        <div className="progress-bar  bg-warning" role="progressbar" style={{ color: '#12242e', fontWeight: 'bolder', width: "33.3333333%" }} aria-valuenow="33" aria-valuemin="0" aria-valuemax="100">33%</div>
                                        <div className="progress-bar  bg-info" role="progressbar" style={{ color: '#12242e', fontWeight: 'bolder', width: "33.3333333%" }} aria-valuenow="33" aria-valuemin="0" aria-valuemax="100">33%</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {accordionTime}


                    <div className="row d-none">
                        {/* Offers */}

                        {/* {idss} */}

                        {/* Testing... */}
                        <div className="col-md-6 ">
                            <div className="card sports-highlights">
                                <h6 className="card-header">Testing...</h6>
                                <div className='card-body'>
                                    <div className="row">
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().over} +6</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().between} 6 - 8</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().between} 9 - 11</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().between} 12 - 14</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().under} +14</span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 ">
                            <div className="card sports-highlights">
                                <h6 className="card-header">Testing...</h6>
                                <div className='card-body'>
                                    <div className="row">
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().over} +4</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().exact} +4</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().under} +4</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().over} +5</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().exact} +5</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().under} +5</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().over}  +6</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().exact} +6</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().under} +6</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().over} +7</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().exact} +7</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().under} +7</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().over} +8</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().exact} +8</span>
                                            </button>
                                        </div>
                                        <div className="col-sm-4 p-1">
                                            <button
                                                className="button-special border border-info">
                                                <span className="text pb-1">{this.props.format('1.9')} </span>
                                                <span className="odds animate text-truncate">{this.props.language().under} +8</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div >
            </div >
        )

    }
}

export default Event;


// WEBPACK FOOTER //
// ./src/components/Event.js